import script from "./AsinDetailsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AsinDetailsModal.vue?vue&type=script&setup=true&lang=js"

import "./AsinDetailsModal.vue?vue&type=style&index=0&id=5de3e0dd&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5de3e0dd"]])

export default __exports__